import React from 'react';
import MaterialTableBody from '@mui/material/TableBody';
import type {TableBodyProps as MaterialTableBodyProps} from '@mui/material/TableBody';

export type TableBodyProps = MaterialTableBodyProps;

export const TableBody = React.forwardRef<any, TableBodyProps>(({
    children, ...props
}, ref) => (
    <MaterialTableBody
        ref={ref}
        {...props}
    >
        {children}
    </MaterialTableBody>
));

TableBody.displayName = 'TableBody';
